module.exports = __webpack_public_path__ + "img/testing.b83b2f2c.svg";